import Progress from 'redux-progress';
import {
  DETAILS,
  CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC,
  IS_EVALUATION_ALLOWED,
  IS_RENEWABLE_ACCOUNT,
  IS_UPGRADABLE_ACCOUNT,
  ADD_CONTACT,
  VALIDATE_CONTACT,
  MAKE_CONTACT_PRIMARY,
} from '../actions/accounts';
import { AccountRenewalAction } from 'util/mac/enums';

export type AccountData = {
  details: object;
  isUpgradableAccount: object;
  isRenewableAccount: object;
  isEvaluationAllowed: Progress<boolean>;
  getAsyncCustomerAccountOverviewsByPartnerSearchDTO: Progress<string>;
  newContact?: Progress<unknown>;
  validateContact?: Progress<unknown>;
  makeContactPrimary?: Progress<string>;
};

export type AccountAction = {
  accountId: string;
  type:
    | typeof DETAILS
    | typeof IS_UPGRADABLE_ACCOUNT
    | typeof IS_RENEWABLE_ACCOUNT
    | typeof IS_EVALUATION_ALLOWED
    | typeof ADD_CONTACT
    | typeof CUSTOMER_ACCOUNT_OVERVIEWS_ASYNC
    | typeof VALIDATE_CONTACT
    | typeof MAKE_CONTACT_PRIMARY;
  progress: Progress<any>;
};

export type CustomerAccountOverviewSearchDTO = {
  partnerId: number;
  accountId?: string;
  accountName?: string;
  mainContactEmail?: string;
  productPackageDescription?: string;
  searchByAnyMatchedField?: boolean;
  expireDate?: Date | string;
  migration?: boolean;
};

export type CustomerAccountOverview = {
  overviews: any[];
  totalCount: number;
};

export type AccountDetail = {
  evaluation: any;
  accountUrl: string;
  id: number;
  status: AccountStatus;
  renewalAction: AccountRenewalAction;
  renewalCurrency: string;
  upcomingCurrencyChange: any;
  renewalCurrencyManuallyOverridden: boolean;
  merchandise: any;
  productDescription: string;
  name: string;
  domain: string;
  parentAccount: boolean;
  parentAccountId: number | null;
  currentUnits: number;
  startDate: string | Date;
  latestPeriod: any;
  latestLicense: any;
  periods: any[];
  isAddOnAccount: boolean;
  children: AccountDetail[];
  contactRelationships: any[];
  invoiceContact: string;
  active: boolean;
  priceOverrideEndDate: string | Date;
  unitUsdOverridePriceExTax: number;
  creditCardData: any;
  cloudSite: any;
  externalUuid: string;
  toBeRenewed: boolean;
  enterpriseSupport: boolean;
  accountPriceOverrideType: any;
  pricingPlan: any;
  accountFriendlyName: string;
  accountProvisioningDate: string | Date;
  deactivated: boolean;
  isSporkMigratedAccountEnabled: boolean;
  isSporkMigratedAccountDisabled: boolean;
  sporkDiscountPercentage: number;
  sporkDiscountStartDate: string | Date;
  sporkDiscountEndDate: string | Date;
  doNotCancel: boolean;
  priceOverrideReason: string;
  halId: string;
  googleAppsEnabled: boolean;
  googleAppsDomain: string;
  hostedDowngradeOrderableItemId: number | null;
  selectedRenewalOverrideOrderableItemId: number | null;
  hostedType: boolean;
  migrationEvaluationDTO: any;
  isExtendedTrial: boolean;
  partnerManaged: boolean;
  txAMigrated: boolean;
  productsBilledInCCP: boolean;
  entSubMigrated: boolean;
  isGovernatorResurrectionInProgress: boolean;
  billingAdminEmails: string[];
  accountForLegacyTier: boolean;
  maxNewRenewalDateForLegacyAccount: string | Date;
  productsBilledSeparately: AccountDetail[];
  provisioningOverridePeriodDTO: any;
  vendorImportCustomerId: string;
  isUnclaimedCloudSite: boolean;
  ccpEntitlementId: string;
  slug: string;
  isAccountExistingInCart: boolean;
  transactionAccountId: string;
  skuVariantId: string;
};

enum AccountStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}
